import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
// import MobileDetect from 'mobile-detect'
import { useTranslation } from 'react-i18next'
import { useImageTranslation } from 'src/hooks'
import { useLocation } from 'react-router-dom'
import ZoomImage from 'src/components/ZoomImage'

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& img': {
        display: 'block',
        width: '100%',
      },
    },
    mobile: {
      maxWidth: 375,
    },
  }),
)

const PaymentTutorial = ({ noTitle }) => {
  const classes = useStyles()
  // const device_type = navigator.userAgent
  // const md = new MobileDetect(device_type)
  // let os = md.os()
  const location = useLocation()
  const { pathname } = location
  const { t, i18n } = useTranslation()
  const [tImage] = useImageTranslation()

  // console.log(os)
  // const isMobile = os === 'iOS' || os === 'AndroidOS'
  return (
    <Box className={classes.root} fontSize="body2.fontSize">
      {!noTitle && (
        <Box fontSize={26} fontWeight={600}>
          {pathname === `/${i18n.language}/add-order/signin` ? '' : t('glossary. use_discount_code')}
          {/* {t('glossary. use_discount_code')} */}
        </Box>
      )}
      <Box fontSize={18} fontWeight={600} ml={-2.5} mt={4}>
        <ul>
          <li>{t('glossary.promotion.step2')}</li>
        </ul>
      </Box>
      <Box fontSize={14} fontWeight={600} color="#4B5563" backgroundColor="none">
        <ZoomImage
          srcThumbnail={tImage('paymentTutorial_mobile_top', 'webp')}
          src={tImage('paymentTutorial_mobile_top', 'webp')}
          alt="mobile payment tutorial 1"
        />
        <Box mt={1.5} mb={4} fontSize={14}>
          {t('glossary.promotion.step0')}
        </Box>
        <Box margin={1} />
        <ZoomImage
          srcThumbnail={tImage('paymentTutorial_mobile_bottom', 'webp')}
          src={tImage('paymentTutorial_mobile_bottom', 'webp')}
          alt="pc payment tutorial 1"
        />
        <Box mt={1.5} mb={4}>
          {t('glossary.promotion.step6')}
        </Box>
      </Box>
    </Box>
  )
}

export default PaymentTutorial
